import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import RequireIcon from '../../components/RequireIcon';

export default function ContactPage() {

  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]);
  const [fileUrls, setFileUrls] = useState('');
  const [isAgree, setIsAgree] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const changeFiles = (e) => {
    const files = e.target.files;

    if (files.length > 3) {
      alert('최대 3개까지만 첨부 가능합니다.');
    }
    else {
      const urls = [];
      for (let i = 0; i < files.length; i++) {
        urls.push(files[i].name)
      }

      setFileUrls(urls.join(', '));
      setFiles(files)
    }
  }

  // 파일을 Base64로 변환
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1]; // data:... 부분 제거
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const clickSubmit = async () => {
    const mobileRegex = /^01[016789]-?\d{3,4}-?\d{4}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    try {
      setIsLoading(true);

      if (!name || !mobile || !email || !title || !content) {
        alert('필수 값이 누락되었습니다. 입력해주세요.')
      }
      else if (!mobileRegex.test(mobile)) {
        alert('전화번호 형식을 확인해주세요.')
      }
      else if (!emailRegex.test(email)) {
        alert('이메일 형식을 확인해주세요.')
      }
      else if (!isAgree) {
        alert('개인 정보 수집 및 이용약관에 동의해주세요.')
      }
      else {
        const attachments = [];
        for (let i = 0; i < files.length; i++) {
          attachments[i] = {
            data: await convertToBase64(files[i]),
            name: uuidv4() + files[i].name,
            type: files[i].type,
          };
        }

        const mailTitle = `[링콜 랜딩페이지 문의] ${title}`;
        const mailContent =
          `
  이름: ${name}
  전화번호: ${mobile}
  이메일: ${email}
  
  문의 내용
  ${content}
        
`

        const data = {
          title: mailTitle,
          content: mailContent,
          attachments
        }

        const res = await axios('https://3lmr55rji6zw63vfz2h6gbubju0tbtua.lambda-url.ap-northeast-2.on.aws', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        });

        alert('문의 접수가 완료되었습니다.');

        setTitle('');
        setContent('');
        setMobile('');
        setEmail('');
        setName('');
        setFiles([]);
        setFileUrls('');
        setIsAgree(false);
      }
    }
    catch (e) {
      console.log(e);
      alert('문의 접수가 실패했습니다. 다시 시도해 주세요.');
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Header />
      <main
        data-bg-type='white'
        className='wrapper top-space bottom-space'
      >
        {
          isLoading &&
          <div
            className="fixed top-0 left-0 flex items-center justify-center w-full h-screen bg-black z-[999] bg-opacity-50">
            <div
              className="w-[100px] h-[100px] border-[10px] border-t-primary-400 border-gray-300 rounded-full animate-spin" />
          </div>
        }

        <h1 className="text-title2 lg:text-display1 text-label-400 text-center">
          문의하기
        </h1>

        <div className="top-space flex flex-col text-body1 lg:text-heading2 text-label-200 [&>label]:mt-[30px] [&>label]:mb-[10px]">
          <label htmlFor="name">이름<RequireIcon /></label>
          <input type="text" id="name" placeholder="홍길동" autoComplete='name'
            required maxLength={10}
            value={name} onChange={(e) => setName(e.target.value)} />

          <label htmlFor="phone">전화번호<RequireIcon /></label>
          <input type="text" id="phone" placeholder="010-0000-0000" autoComplete='tel'
            required maxLength={15}
            value={mobile} onChange={(e) => setMobile(e.target.value)} />

          <label htmlFor="email">이메일<RequireIcon /></label>
          <input type="email" id="email" placeholder="example@gmail.com" autoComplete='email'
            required maxLength={100}
            value={email} onChange={(e) => setEmail(e.target.value)} />

          <label htmlFor="title">제목<RequireIcon /></label>
          <input type="text" id="title" placeholder="제목을 입력해주세요." autoComplete="title"
            required maxLength={50}
            value={title} onChange={(e) => setTitle(e.target.value)} />

          <label htmlFor="content">
            문의 내용<RequireIcon />
          </label>
          <textarea id="content" className="min-h-[230px]" placeholder="문의할 내용을 입력해주세요."
            required maxLength={2000}
            value={content} onChange={(e) => setContent(e.target.value)} />

          <label htmlFor="files-url">첨부파일</label>
          <div className='flex flex-wrap gap-[10px]'>
            <input className='flex-1' id="files-url" type="text" value={fileUrls} disabled />
            <label htmlFor="files"
              className="
                   flex items-center
                   px-[10px] py-[16px] rounded-[20px] bg-black
                   text-white text-body2 lg:text-heading3
                   cursor-pointer
                   ">
              첨부파일 선택
            </label>
            <input className="absolute w-0 h-0 p-0 overflow-hidden border-0" type="file" id="files" multiple
              onChange={changeFiles} />
          </div>
        </div>

        <div className="flex items-center mt-[100px] mb-[30px]">
          <input type="checkbox" id="privacy" required
            style={{ zoom: 1.5, cursor: 'pointer' }}
            checked={isAgree} onChange={(e) => setIsAgree(e.target.checked)} />
          <label htmlFor="privacy" className='ml-[10px] text-heading3 cursor-pointer'>개인 정보 수집 및 이용약관에 동의합니다.</label>
        </div>

        <button className="w-full py-[16px] lg:py-[30px] text-body2 lg:text-heading2" disabled={isLoading} onClick={clickSubmit}>
          문의하기
        </button>
      </main>
      <Footer />
    </div>
  )
}